import router from '@/router'
import store from '@/store'
import { PageEnum } from '@/enums/pageEnum'
import { PAGE_NOT_FOUND_NAME, REDIRECT_NAME } from '@/router/constant'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

router.beforeEach(async (to, from, next) => {
  // console.log('to.path--', to.path)
  // console.log('from.path--', from.path)
  NProgress.start()

  // if (to.name === REDIRECT_NAME) {
  //   next()
  //   return
  // }
  const homePage = store.getters['user/getHomePage']
  // if (REDIRECT_NAME.includes(from.name) && to.path === '/') {
  //   next({ path: homePage || PageEnum.BASE_HOME, query: to.query })
  //   return
  // }

  if (to.path === PageEnum.BASE_HOME && homePage && homePage !== PageEnum.BASE_HOME) {
    next(homePage)
    return
  }

  if (PageEnum.BASE_LOGIN.includes(to.path)) {
    next()
    return
  }

  // console.log({ homePage })
  if (PageEnum.BASE_LOGIN.includes(from.path) && to.fullPath !== (homePage || PageEnum.BASE_HOME)) {
    next(homePage || PageEnum.BASE_HOME)
    // next({ path: to.fullPath })
    return
  }

  // if (store.getters['user/getUserInfo'] === null) {
  //   next({ path: '/login' })
  //   return
  // }

  if (store.getters['permission/getIsDynamicAddedRoute']) {
    next()
    return
  }

  try {
    await store.dispatch('user/getUserInfoAction')
  } catch (error) {
    next({ path: '/login' })
    return
  }

  const accessRoutes = await store.dispatch('permission/buildRoutesAction')

  console.log('---accessRoutes---', accessRoutes)
  if (accessRoutes) {
    accessRoutes.forEach((route) => {
      router.addRoute('Root', route)
    })

    store.commit('permission/setDynamicAddedRoute', true)
  }

  if (to.name === PAGE_NOT_FOUND_NAME) {
    next({ path: to.fullPath, replace: true, query: to.query })
  } else {
    next({ ...to, replace: true })
  }
})

router.afterEach((to) => {
  // console.warn('afterEach')
  NProgress.done()
  if (PageEnum.BASE_LOGIN.includes(to.path)) {
    if (store.getters['user/getUserInfo'] !== null) {
      localStorage.removeItem('loginInfo')
      // window.location.reload()
    }
  }
})
